module.exports = __webpack_public_path__ + "static/media/workbrook-league.3799f967.png";